import {AvailabilityState, KpiStatusEnum, KpiStatusPrognoseEnum, KPITypeEnum, MijlpaalEnum, MijlpaalPrognoseEnum, OnderwerpEnum, PeriodEnum, PrognoseSchaalEnum, StatusEnum, WaardeTypeEnum, WachttijdApiTypeEnum} from './enums&types.js';
import {CabPeriod, CabReportItem, REPORTED_VALUE_UNKNOWN} from './index.js';

export function PeriodEnum_name(e: PeriodEnum): string {
    switch (e) {
        case PeriodEnum.Q:
            return 'kwartaal';
        case PeriodEnum.H:
            return 'half jaar';
    }
}

export function PeriodEnum_char(e: PeriodEnum): string {
    switch (e) {
        case PeriodEnum.Q:
            return 'Q';
        case PeriodEnum.H:
            return 'H';
    }
}

export function OnderwerpEnum_name(e: OnderwerpEnum | undefined): string {
    switch (e) {
        //case OnderwerpEnum.mijlpaal:
        case OnderwerpEnum.proces:
            return 'Proces';
        case OnderwerpEnum.adherentie:
            return 'Adherentie';
        case OnderwerpEnum.financien:
            return 'Financiën';
        case OnderwerpEnum.personeel:
            return 'Personeel';
        case OnderwerpEnum.productiviteit:
            return 'Productiviteit';
        case OnderwerpEnum.quadrupleAim:
            return 'Quadruple Aim';
        case OnderwerpEnum.toegankelijkheid:
            return 'Toegankelijkheid';
        case OnderwerpEnum.volumes:
            return 'Volumes';
        default:
            return '???';
    }
}

const OnderwerpEnum_sortering: OnderwerpEnum[]         = [
    OnderwerpEnum.proces,
    OnderwerpEnum.financien,
    OnderwerpEnum.personeel,
    OnderwerpEnum.volumes,
    OnderwerpEnum.toegankelijkheid,
    OnderwerpEnum.productiviteit,
    OnderwerpEnum.adherentie,
    OnderwerpEnum.quadrupleAim,
];
const onderwerpSorteerPrio: Map<OnderwerpEnum, number> = new Map(OnderwerpEnum_sortering.map((enumValue, index) => [enumValue, index]));

export function OnderwerpEnum_compare(a: OnderwerpEnum, b: OnderwerpEnum): number {
    return onderwerpSorteerPrio.get(a)! - onderwerpSorteerPrio.get(b)!;
}

export function WaardeTypeEnum_name(e: WaardeTypeEnum): string {
    switch (e) {
        case WaardeTypeEnum.getal:
            return 'geheel getal';
        case WaardeTypeEnum.percentage:
            return '% percentage';
        case WaardeTypeEnum.bedrag:
            return '€ bedrag';
        case WaardeTypeEnum.decimaal:
            return 'decimaal getal';
    }
}

export function VoorspellingsSchaalEnum_name(e: PrognoseSchaalEnum | undefined): string {
    switch (e) {
        case PrognoseSchaalEnum.none:
            return 'geen prognose';
        case PrognoseSchaalEnum.once:
            return 'één prognose';
        case PrognoseSchaalEnum.all:
            return 'traject prognose';
        default:
            return '???';
    }
}

export function KPITypeEnum_name(e: KPITypeEnum) {
    switch (e) {
        case KPITypeEnum.input:
            return 'input KPI';
        case KPITypeEnum.output:
            return 'output KPI';
        case KPITypeEnum.onderliggend:
            return 'onderliggende KPI';
    }
}

export function MijlpaalEnum_name(e: MijlpaalEnum | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case MijlpaalEnum.gehaald:
            return 'mijlpaal gehaald';
        case MijlpaalEnum.gemist:
            return 'mijlpaal gemist';
        case MijlpaalEnum.onbekend:
            return 'mijlpaal status onbekend';
        case MijlpaalEnum.gestart:
            return 'mijlpaal gestart';
    }
    return geenWaardePresentatie;
}

export function KpiStatusEnum_name(e: KpiStatusEnum | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case KpiStatusEnum.gehaald:
            return 'KPI gehaald';
        case KpiStatusEnum.gemist:
            return 'KPI gemist';
        case KpiStatusEnum.onbekend:
            return 'KPI status onbekend';
    }
    return geenWaardePresentatie;
}

export function MijlpaalPrognoseEnum_name(e: MijlpaalPrognoseEnum | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case MijlpaalPrognoseEnum.wordtGehaald:
            return 'mijlpaal zal worden gehaald';
        case MijlpaalPrognoseEnum.kansOpMissen:
            return 'kans op missen mijlpaal aanwezig';
        case MijlpaalPrognoseEnum.wordtGemist:
            return 'mijlpaal zal worden gemist';
    }
    return geenWaardePresentatie;
}

export function KpiStatusPrognoseEnum_name(e: KpiStatusPrognoseEnum | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case KpiStatusPrognoseEnum.wordtGehaald:
            return 'KPI zal worden gehaald';
        case KpiStatusPrognoseEnum.kansOpMissen:
            return 'kans op missen KPI aanwezig';
        case KpiStatusPrognoseEnum.wordtGemist:
            return 'KPI zal worden gemist';
    }
    return geenWaardePresentatie;
}

export function AvailabilityState_name(e: AvailabilityState | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case AvailabilityState.closed:
            return 'gesloten';
        case AvailabilityState.read:
            return 'alleen-lezen';
        case AvailabilityState.write:
            return 'open';
    }
    return geenWaardePresentatie;
}

export function StatusEnum_name(e: StatusEnum | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case StatusEnum.future:
            return 'toekomst';
        case StatusEnum.open:
            return 'open';
        case StatusEnum.overdue:
            return 'overtijd';
        case StatusEnum.submitted:
            return 'ingediend';
        case StatusEnum.accepted:
            return 'geaccepteerd';
        case StatusEnum.rejected:
            return 'afgewezen';
    }
    return geenWaardePresentatie;
}

export function WachttijdApiTypeEnum_name(e: WachttijdApiTypeEnum | undefined | 'CSV', geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    switch (e) {
        case WachttijdApiTypeEnum.MSZ:
            return 'MSZ';
        case WachttijdApiTypeEnum.GGZ:
            return 'GGZ';
        case 'CSV':
            return 'CSV';
    }
    return geenWaardePresentatie;
}

export function StatusEnum_color(e: StatusEnum | undefined) {
    return `${StatusEnum_baseColor(e)}-${e === StatusEnum.future ? 300 : 200}`;
}

export function StatusEnum_heavyColor(e: StatusEnum | undefined) {
    return `${StatusEnum_baseColor(e)}-${e === StatusEnum.future ? 400 : 300}`;
}

// see tailwind.config.js, if you change this, make equivalent changes there!
const OVERDUE_COLOR: string   = 'orange';
const OPEN_COLOR: string      = 'blue';
const FUTURE_COLOR: string    = 'slate';
const SUBMITTED_COLOR: string = 'lime';
const ACCEPTED_COLOR: string  = 'teal';
const UNDEFINED_COLOR: string = 'lime';
const REJECTED_COLOR: string  = 'red';

export function StatusEnum_baseColor(e: StatusEnum | undefined) {
    switch (e) {
        case StatusEnum.overdue:
            return OVERDUE_COLOR;
        case StatusEnum.open:
            return OPEN_COLOR;
        case StatusEnum.future:
            return FUTURE_COLOR;
        case StatusEnum.submitted:
            return SUBMITTED_COLOR;
        case StatusEnum.accepted:
            return ACCEPTED_COLOR;
        case StatusEnum.rejected:
            return REJECTED_COLOR;
    }
    return UNDEFINED_COLOR;
}

export function renderCabPeriod(p: CabPeriod): string {
    return `${p.year}-${PeriodEnum_char(p.unit)}${p.num + 1}`;
}

export function renderSet(s: Set<any>) {
    return '[' + [... s].map(e => JSON.stringify(e)).join(',') + ']';
}

const GEEN_WAARDE_REPRESENTATION = '';

export function formatWaarde(waarde: number | undefined, waardeType: WaardeTypeEnum | undefined, includeUnit = true, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): string {
    if (waarde == undefined) {
        return geenWaardePresentatie;
    }
    if (waarde === REPORTED_VALUE_UNKNOWN) {
        return 'onbekend';
    }
    const neg = waarde < 0;
    if (neg) {
        waarde = -waarde;
    }
    const formattedNumber: string = waarde.toLocaleString('en-US', {
        minimumFractionDigits: waardeType == WaardeTypeEnum.decimaal ? 2 : waardeType == WaardeTypeEnum.percentage ? 1 : 0,
        maximumFractionDigits: waardeType == WaardeTypeEnum.decimaal ? 2 : waardeType == WaardeTypeEnum.percentage ? 1 : 0,
        useGrouping          : true,
    }).replace(/,/g, 'X')
        .replace(/[.]/g, ',')
        .replace(/X/g, '.');

    const sign: string      = neg ? '- ' : '';
    const unit_pre: string  = waardeType === WaardeTypeEnum.bedrag ? '€ ' : '';
    const unit_post: string = waardeType === WaardeTypeEnum.percentage ? ' %' : '';
    return includeUnit ? sign + unit_pre + formattedNumber + unit_post : (sign + formattedNumber).replace(/ /g, '');
}

export function parseWaarde(value: string | undefined, geenWaardePresentatie: string = GEEN_WAARDE_REPRESENTATION): number | undefined {
    if (value === undefined) {
        return undefined;
    }
    if (value === geenWaardePresentatie) {
        return undefined;
    }
    if (value === 'onbekend') {
        return REPORTED_VALUE_UNKNOWN;
    }
    const neg: boolean = (value.replace(/[^-]/g, '').length % 2) == 1;
    const v: string    = value
        .replace(/[^0-9,.]/g, '')
        .replace(/^$/, '0')
        .replace(/^0([0-9])/, '$1')
        .replace(/[.]/g, '')
        .replace(/,/, '.')
        .replace(/,/g, '')
    ;
    return v === '' ? undefined : neg ? -v : +v;
}

export function renderRI_debug(ri: CabReportItem): string {
    return `RI[${ri.uuid} ${renderCabPeriod(ri.period[0])} ## ${ri.kpi[0].name} ## ${ri.organization[0].name} ## ${ri.theme[0].name}`;
}

export function renderReportItemFull(ri: CabReportItem): string {
    return `${renderCabPeriod(ri.period[0])}|${ri.organization[0].name}|${ri.theme[0].name}|${ri.kpi[0].name}`;
}

export function renderReportItemShort(ri: CabReportItem): string {
    return `${renderCabPeriod(ri.period[0])} | ${condense(ri.organization[0].name)} | ${condense(ri.theme[0].name)} | ${condense(ri.kpi[0].name)}`;
}

export function condense(str: string, maxLength = 21) {
    if (str.length <= maxLength) {
        return str;
    }
    const half: number = Math.floor((maxLength - 3) / 2); // -3 accounts for '...'
    return `${(str.substring(0, half))}...${(str.substring(str.length - half))}`;
}

export function formatIntegerAligned(w: number, num: number): string {
    return num.toLocaleString('en-US', {useGrouping: true}).padStart(w);
}

export function formatPercentageAligned(w: number, num: number): string {
    return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping          : true,
    }).padStart(w) + ' %';
}

export function formatDecimalAligned(w: number, num: number): string {
    const formatted: string = num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping          : true,
    });
    const parts: string[]   = formatted.split('.');
    return parts[0].padStart(w) + '.' + parts[1];
}

export function formatMemSizeAligned(w: number, bytes: number): string {
    const units: string[] = ['B', 'KB', 'MB'];
    const k: number       = 1024;
    if (bytes === 0) {
        return `${formatIntegerAligned(w, 0)} ${units[0]}`;
    }
    const i: number = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(k)));
    if (i === 0) {
        // For bytes, show as integer
        return `${formatIntegerAligned(w, bytes)} ${units[i]}`;
    }
    // For larger units, show with 2 decimal places
    const size: number = bytes / Math.pow(k, i);
    return `${formatDecimalAligned(w, size)} ${units[i]}`;
}
